import { HTMLAttributes } from "react";
import PublicHead from "./head";
import { WebJiraDesk } from "@meitu/jira-reporter";
// import Footer from "./footer";

interface IProps extends HTMLAttributes<HTMLDivElement> {}

const Layout = (props: IProps) => {
  const { children } = props;

  return (
    <div>
      <PublicHead />
      {
        process.env.NEXT_PUBLIC_ENV !== 'release' && (
          <WebJiraDesk />
        )
      }
      {/* <Header isPersonal={isPersonal} /> */}
      <main>{children}</main>
      {/* <Footer friendLinks={friendLinks} /> */}
    </div>
  );
};

export default Layout;
